export default "__VITE_ASSET__xmEPP2Bf__"